import { createFormAction } from 'redux-form-saga';
import * as cosAnnexeTRFormTypes from './cosAnnexeTRFormTypes';

export const submitCosAnnexeTRForm = createFormAction(cosAnnexeTRFormTypes.SUBMIT_COS_ANNEXE_TR_FORM);
